function Footer() {
    return (
        <footer className="py-4 text-center border-t border-gray-200 dark:border-gray-700">
        <p className="text-sm">&copy; 2025 My Website. All rights reserved.</p>
      </footer>
    );
  }
  
export default Footer;
  